
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Logo from "@/components/common/Logo";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";
import { cn } from "@/lib/utils";

const BuyerPricingHeader = () => {
  const { topPadding } = useSafeAreaInsets();
  return (
    <header className={cn("border-b border-gray-800", topPadding)}>
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/buyer">
          <Logo size="medium" />
        </Link>
        <div className="space-x-4">
          <Link to="/buyer/login">
            <Button variant="outline" className="border-[#ffd700] text-[#ffd700]">Login</Button>
          </Link>
          <Link to="/buyer/register">
            <Button className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200]">
              Get Started
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default BuyerPricingHeader;
